import axios from "axios";
import { environment } from './environment'
import { saveAs } from 'file-saver';
const endpoint = environment.serverUrl;

export async function TranslationDefinitions(shopUrl) {
    return axios
    .get(endpoint+'/api/Translation/translation-definitions?storeUrl=' + shopUrl)
    .then(function(response) {
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return []
    })
  }

  export async function TranslationFields(shopUrl,type) {
    return axios
    .get(endpoint+'/api/Translation/translation-fields?storeUrl=' + shopUrl + '&type=' + type)
    .then(function(response) {
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return []
    })
  }

  export async function downloadTranslationBulkResult(storeUrl,bulkId,type) {
    try {
      const response = await axios.get(endpoint+"/api/Translation/download-bulk-result?storeUrl=" +storeUrl + "&bulkId="+bulkId +"&type=" + type, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "text/plain" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "result-"+storeUrl+"-"+type+".csv");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
        console.error(error);
    }
  };

  export async function translationBulkCancel(storeUrl,bulkId) {
    return await axios
        .post(endpoint+"/api/Translation/bulk-cancel?storeUrl=" +storeUrl + "&bulkId="+bulkId)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}

export async function TranslationBulkPolling(storeUrl) {
    return await axios
        .get(endpoint + '/api/Translation/bulk-polling?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function DeleteTranslationLogs(storeUrl) {
    return await axios
        .delete(endpoint+'/api/Translation/delete-older-logs?storeUrl=' +storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })   
}

export async function getTranslationImportHistory(storeUrl,pageNo, pageSize) {
    return await axios
        .get(endpoint + '/api/Translation/import-logs?storeUrl='+ storeUrl + '&pageNo='+pageNo + '&pageSize='+pageSize)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

// export async function translationExportStatus(storeUrl) {
//     return await axios
//         .get(endpoint + '/api/Translation/export-status?storeUrl='+storeUrl)
//         .then(function (response) {
//             if (response.status === 200 && response != null) {
//                 return response.data
//             } else {
//                 throw new Error('Empty data')
//             }
//         })
//         .catch(function (error) {
//             console.log(error)
//             return null
//         })
// }
